(function (window, document) {
    // next link element
    var nextElement = document.querySelector('.js-button-pagination');
    if (!nextElement) {
        return;
    }

    // post feed element
    var feedElement = document.querySelector('.post-feed');
    if (!feedElement) {
        return;
    }
    var ticking = false;

    function onPageLoad() {

        // append contents
        var postElements = this.response.querySelectorAll('article.post');
        postElements.forEach(function (item) {
            // document.importNode is important, without it the item's owner
            // document will be different which can break resizing of
            // `object-fit: cover` images in Safari
            feedElement.appendChild(document.importNode(item, true));
            console.log(postElements);
        });

        nextElement.classList.remove('loading');
        pagination_next_page_number++;

        // If you are on the last pagination page, hide the load more button
        if (pagination_next_page_number > pagination_available_pages_number) {
            nextElement.classList.add('disabled');
        }

        // set next link
        var resNextElement = this.response.querySelector('link[rel=next]');
        if (resNextElement) {
            nextElement.href = resNextElement.href;
        } else {
            nextElement.classList.add('disabled');
        }


    }

    function onUpdate() {

        var xhr = new window.XMLHttpRequest();
        xhr.responseType = 'document';

        xhr.addEventListener('load', onPageLoad);

        xhr.open('GET', nextElement.href);

        //add loading class to load more button
        nextElement.classList.add('loading');
        xhr.send(null);
    }

    function requestTick() {
        ticking || window.requestAnimationFrame(onUpdate);
        ticking = false;
    }

    //OnClick Action
    nextElement.addEventListener('click', function (e) {
        e.preventDefault();
        requestTick();
    });

})(window, document);
